"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var react_redux_1 = require("react-redux");
var ColumnSelection_styles_1 = __importDefault(require("./ColumnSelection.styles"));
var Button_1 = __importDefault(require("../../atoms/Button/Button"));
var columnData_1 = require("../../../data/columnData");
var InputCheckbox_1 = __importDefault(require("../../atoms/InputCheckbox/InputCheckbox"));
var columnFiltersSlice_1 = require("../../../store/columnFiltersSlice");
var ColumnSelection = function () {
    var dispatch = react_redux_1.useDispatch();
    var columnFilters = react_redux_1.useSelector(function (state) { return state.filters.chosenColumnFilters; });
    var _a = react_1.useState(false), modalIsOpen = _a[0], setIsOpen = _a[1];
    var _b = react_1.useState(columnData_1.columnData), columns = _b[0], setColumns = _b[1];
    var _c = react_1.useState([]), columnsToFilter = _c[0], setColumnsToFilter = _c[1];
    react_1.useEffect(function () {
        // get array of filter state from redux
        Object.keys(columns).map(function (key) { return (columns[key].data.map(function (item, index) { return (columnFilters && columnFilters.includes(item.name) ? setCheckboxStateOnLoad(key, index) : null); })); });
        setColumnsToFilter(columnFilters);
    }, [columnFilters]);
    var openModal = function () {
        setIsOpen(true);
    };
    // Don't send filter state to redux
    var closeModal = function () {
        setIsOpen(false);
    };
    // set filter state to redux
    var confirmCloseModal = function () {
        // send state to API
        axios_1.default({
            method: 'PUT',
            url: '/api/user/context',
            data: columnsToFilter,
            headers: { 'Content-Type': 'application/json' },
        })
            .then(function (res) {
            dispatch(columnFiltersSlice_1.setColumnFilters(columnsToFilter));
            setIsOpen(false);
        })
            .catch(function (error) {
            console.error(error.response.data.errors);
        });
    };
    var setCheckboxStateOnLoad = function (category, index) {
        setColumns(function (prevState) {
            var newState = __assign({}, prevState);
            newState[category].data[index].visible = false;
            return newState;
        });
    };
    var handleCheckboxChange = function (category, index, name) {
        // handles checkboxes state
        setColumns(function (prevState) {
            var newState = __assign({}, prevState);
            newState[category].data[index].visible = !newState[category].data[index].visible;
            return newState;
        });
        // updates array of filters
        setColumnsToFilter(function (prevState) {
            var newFilters = __spreadArrays(prevState);
            return newFilters.includes(name) ? newFilters.filter(function (i) { return i !== name; }) : __spreadArrays(newFilters, [name]);
        });
    };
    return (react_1.default.createElement(ColumnSelection_styles_1.default, null,
        react_1.default.createElement(Button_1.default, { onClick: openModal },
            react_1.default.createElement("span", null, "Pas kolommen aan")),
        modalIsOpen &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "modal" },
                    react_1.default.createElement("button", { className: "modal__close", onClick: closeModal },
                        react_1.default.createElement("svg", { className: "icon icon-close", "aria-hidden": "true" },
                            react_1.default.createElement("use", { xmlnsXlink: 'http://www.w3.org/1999/xlink', xlinkHref: '/dist/svg/sprite.min.svg#cross' }))),
                    react_1.default.createElement("h2", { className: "title" }, "Pas kolommen aan"),
                    react_1.default.createElement("p", { className: "description" }, "Vink de kolommen aan die je wilt laten zien in het overzicht."),
                    react_1.default.createElement("div", { className: "column-controls" }, Object.keys(columns).map(function (key) { return (react_1.default.createElement("div", { className: "category", key: key },
                        react_1.default.createElement("p", { className: "category__label" }, columns[key].label),
                        columns[key].data.map(function (item, index) { return (react_1.default.createElement(InputCheckbox_1.default, { key: index, id: item.name, label: item.label, checked: item.visible, valueChanged: function () { return handleCheckboxChange(key, index, item.name); } })); }))); })),
                    react_1.default.createElement("div", { className: "save" },
                        react_1.default.createElement(Button_1.default, { className: "secondary", onClick: confirmCloseModal },
                            react_1.default.createElement("span", null,
                                "Bevestig",
                                react_1.default.createElement("svg", { className: "icon icon-plus", "aria-hidden": "true" },
                                    react_1.default.createElement("use", { xmlnsXlink: 'http://www.w3.org/1999/xlink', xlinkHref: '/dist/svg/sprite.min.svg#arrow-right' })))))),
                react_1.default.createElement("div", { className: "modal__underlay" }))));
};
exports.default = ColumnSelection;
